import React from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { Button } from '@change-corgi/design-system-legacy/components/actions';
import { Avatar } from '@change-corgi/design-system-legacy/components/media';
import { Flex } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

import { useCreateVideo } from './hooks/useCreateVideo';

export function CreateVideo(): React.JSX.Element | null {
	const {
		data: { username, userHasSigned },
		actions: { createVideoClickHandler },
	} = useCreateVideo();

	return (
		<Flex
			data-testid="create-video-ask"
			sx={{
				flexShrink: 0,
				height: 244,
				width: 170,
				px: 16,
				gap: 16,
				flexDirection: 'column',
				justifyContent: 'center',
				alignItems: 'center',
				background: 'primary-greyBackground',
				borderRadius: 'standard',
			}}
		>
			<Avatar alt="avatar" size={60} src="https://assets.change.org/photos/5/rm/sw/fqRMSWIetwCbMdr-400x400-noPad.jpg" />

			<Text
				as="p"
				sx={{
					textAlign: 'center',
				}}
			>
				{userHasSigned ? (
					<Translate value="corgi.petition_gamma.videos.cta.with_name" replacements={{ username }} />
				) : (
					<Translate value="corgi.petition_gamma.videos.cta.without_name" />
				)}
			</Text>

			{userHasSigned && (
				<Button
					size="small"
					onClick={createVideoClickHandler}
					data-testid="create-video-button"
					data-qa="create-video-button"
					variant="secondary"
					sx={{ width: '100%' }}
				>
					<Translate value="corgi.petition_gamma.videos.create" />
				</Button>
			)}
		</Flex>
	);
}
